import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { MediaContext } from "../../common/media-context";

import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import EditColumn from "../../common/EditColumn";

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
  },
}));

const IapSelectCheckbox = props => {
  const classes = useStyles();
  const context = useContext(MediaContext);
  const formBuilder = handlers => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            checked={Boolean(context.media.iapSelect)}
            onChange={handlers.onCheckboxChange("iapSelect")}
            name="content-iapSelect"
            inputProps={{ "aria-label": "Select" }}
          />
        }
        label="IAP Select"
      />
    );
  };

  return <EditColumn className={classes.root} formBuilder={formBuilder} />;
};

export default IapSelectCheckbox;
